/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import emptyImage from "../../assets/empty-image.png";

class FootprintImage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            imageStatus: "loading",
            imageUrl: props.imageUrl,
            loading: false,
            error: false,
        };
    }


    render() {
        const { imageStyles = {} } = this.props;
        return (
            <div>
                {(this.state.error === false) && <img
                    onLoadStart={() => {
                        this.setState({ loading: true })
                    }}
                    onError={() => {
                        this.setState({ onError: true })
                    }}
                    src={(this.state.onError || this.state.loading) ? emptyImage :
                        this.props.imageUrl}
                    style={{
                        height: 100,
                        width: 100,
                        ...imageStyles
                    }}

                ></img>
                }
                {(this.state.error === true) && <img
                    onLoadStart={() => {
                        this.setState({ loading: true })
                    }}
                    onError={() => {
                        this.setState({ onError: true })
                    }}
                    src={emptyImage}
                    // src={require('../../assets/empty-image.png')}
                    style={{
                        height: 100,
                        width: 100,
                        ...imageStyles
                    }}

                ></img>
                }
            </div>
        );
    }
}
export default FootprintImage;
